
<div class="container">
  <app-header></app-header>
  <div class="dashboard__content content">
    <div class="row">
      <div class="col-xsmall-12 dashboard-cards">
        @if (voucherEnabled$ | async) {
          <app-dashboard-card
            (action)="SetEvent($event, DashboardRoutesType.Voucher)"
            [title]="'PAGES.DASHBOARD.VOUCHER_CARD.TITLE' | translate"
            [text]="'PAGES.DASHBOARD.VOUCHER_CARD.TEXT' | translate"
            [type]="DashboardCardType.Voucher"></app-dashboard-card>
        }
        @if (event$ | async; as event) {
          <app-dashboard-card (action)="SetEvent($event, DashboardRoutesType.EventOverview)" [title]="event.title" [type]="DashboardCardType.Event" [event]="event"></app-dashboard-card>
        }

      </div>
    </div>
    <div class="spacer-2"></div>


    <div class="row">
      <div class="col-xsmall-12">
        <div class="dashboard__infos-header">
          <div class="dashboard__infos-title card-title">{{ 'PAGES.INFO_OVERVIEW.TITLE' | translate}}</div>
          <div class="dashboard__infos-button"></div>
          <app-text-button (action)="SetEvent($event, DashboardRoutesType.NewsOverview, '', {tab: ModerationSate.PUBLISHED})" label="{{'PAGES.DASHBOARD.NEWS_ALL'}}"></app-text-button>
        </div>
        @if ((newsToApprove$ | async)?.count > 0) {
          <div class="spacer-1"></div>
          <app-notification-banner (action)="SetEvent($event, DashboardRoutesType.NewsOverview, '', {tab: ModerationSate.WAITING_FOR_APPROVAL})" [count]="$safeNavigationMigration((newsToApprove$ | async)?.count)">
            <p class="button-text">{{ ((ownRejectedNewsPosts$ | async)?.count === 1 ? 'PAGES.DASHBOARD.NOTIFICATION_BANNER.SINGULAR' : 'PAGES.DASHBOARD.NOTIFICATION_BANNER.PLURAL') | translate: {value: ($safeNavigationMigration((newsToApprove$ | async)?.count))} }}</p>
          </app-notification-banner>
        }
        @if ((ownRejectedNewsPosts$ | async)?.count > 0) {
          <div class="spacer-1"></div>
          <app-notification-banner (action)="SetEvent($event, DashboardRoutesType.NewsOverview, '', {tab: ModerationSate.OWN_REJECTED})" [count]="$safeNavigationMigration((ownRejectedNewsPosts$ | async)?.count)">
            <p class="button-text">{{ ((ownRejectedNewsPosts$ | async)?.count === 1 ? 'PAGES.DASHBOARD.NOTIFICATION_BANNER_REJECTED.SINGULAR' : 'PAGES.DASHBOARD.NOTIFICATION_BANNER_REJECTED.PLURAL') | translate: {value: ($safeNavigationMigration((ownRejectedNewsPosts$ | async)?.count))} }}</p>
          </app-notification-banner>
        }
        <div class="spacer-1"></div>
        @if (newsPosts) {
          <div [@listAnimation]="newsPosts.length">
            @for (newsPost of newsPosts; track track(i, newsPost); let i = $index) {
              @if (i < NEWS_ITEMS_TO_SHOW) {
                <app-info-card
                  (action)="SetEvent($event, DashboardRoutesType.NewsDetail, newsPost.id)"
                  [title]="newsPost.attributes.field_teaser_title || newsPost.attributes.title"
                  [federalStates]="newsPost.attributes.federalStates"
                  [infoDate]="newsPost.attributes.publication_date"
                  [new]="!newsPost.attributes.is_read"
                  >
                </app-info-card>
              }
            }
          </div>
        } @else {
          <app-loading></app-loading>
        }
        <app-load-more-button [viewHelper]="viewHelper" [hideOnElements]="NEWS_ITEMS_TO_SHOW"></app-load-more-button>
        <div class="spacer-2"></div>
      </div>
    </div>
  </div>
</div>


